var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('landing-create', {
    attrs: {
      "content": _vm.content
    }
  }), _vm.caseNumber ? _c('case-form', {
    attrs: {
      "isLoading": _vm.isLoading,
      "onSubmit": _vm.onSubmit,
      "caseNumber": _vm.caseNumber
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }